import { useMemo } from 'react'
import { kebabCase } from 'lodash'
import { useFormikContext } from 'formik'
import { Textarea } from '@windmill/react-ui'

import styles from './Input.module.css'

const TextArea = ({ id, name, rows, label, ariaLabel, placeholder }) => {
    const { handleBlur, handleChange, getFieldMeta } = useFormikContext() || {}
    const { value, error, touched } = getFieldMeta ? getFieldMeta(name) : {}
    const id$ = useMemo(() => id || `${kebabCase(label)}`, [id, label])

    return (
        <div>
            <div className={styles.formGroup}>
                <label
                    htmlFor={id$}
                    className="mb-1.5 block font-medium text-interface-900"
                >
                    {label}
                </label>
                <Textarea
                    id={id$}
                    name={name}
                    className={`${styles.formControl} ${
                        error && touched ? styles.hasError : ''
                    }`}
                    aria-label={ariaLabel ? ariaLabel : label}
                    rows={rows ? rows : 3}
                    placeholder={placeholder}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={value}
                />
            </div>
        </div>
    )
}

export default TextArea
